var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("GridHome", {
        attrs: {
          "row-data": _vm.comunicaciones,
          gridOptions: _vm.gridOptions,
          funcionalidadId: _vm.funcionalidad
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }